import { action } from 'satcheljs';

export interface UpdateInternetMessageIdActionMessage {
    conversationId: string | undefined;
    internetMessageId: string;
}
const defaultExport: (
    conversationId: string | undefined,
    internetMessageId: string
) => UpdateInternetMessageIdActionMessage = action(
    'updateInternetMessageId',
    (
        conversationId: string | undefined,
        internetMessageId: string
    ): UpdateInternetMessageIdActionMessage => ({
        conversationId,
        internetMessageId,
    })
);
export default defaultExport;
